<template>
  <div>
    <span v-for="entrepreneur in entrepreneurs" :key="entrepreneur.id">
      {{ entrepreneur.prenom }}
      <span v-if="entrepreneur.age !== -1">{{ $t('entrepreneur-age-text', { age: entrepreneur.age }) }}</span>
      <span>{{ getSeparator(entrepreneur.id) }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    entrepreneurs: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    }
  },
  methods: {
    getSeparator: function(entrepreneurId) {
      const index = this.entrepreneurs.findIndex(x => x.id === entrepreneurId)
      const nextIndex = index + 1
      const lastIndex = this.entrepreneurs.length - 1

      if (nextIndex <= lastIndex) {
        if (nextIndex === lastIndex) {
          return ' ' + this.$t('and') + ' '
        }
        return ', '
      }
      return ''
    }
  }
}
</script>
